import React from 'react'

export const GooglePlayButton = ({ url, description = 'Link to GooglePlay store' }) => {
  return (
    <a href={url} target="_blank" rel="noreferrer">
      <img className="m-3  " alt={description} src="/assets/img/playStore_button.png" />
    </a>
  )
}
